// extracted by mini-css-extract-plugin
export default {"component":"page_component__L1WbA","title":"page_title__XNMol","titleCounter":"page_titleCounter__XTYcg","btn":"page_btn__fo1Er"};